import { render, staticRenderFns } from "./LoadInventory.vue?vue&type=template&id=297bd9c4&scoped=true"
import script from "./LoadInventory.vue?vue&type=script&lang=js"
export * from "./LoadInventory.vue?vue&type=script&lang=js"
import style0 from "./LoadInventory.vue?vue&type=style&index=0&id=297bd9c4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297bd9c4",
  null
  
)

export default component.exports